<script>
    import { onMount } from "svelte";

    import { TabulatorFull as Tabulator } from "tabulator-tables";

    import { getLocaleResource } from "../utils/locales.js";

    import { fetchGet } from "../utils/utilsFetch.js";

    import { productsTableColumns } from "../utils/utilsTabulator.js";

    import { isLoading, locale, scrollToSku } from "../stores.js";

    let products = [],
        table,
        tableElement;

    onMount(async () => {
        $isLoading = true;

        products = await fetchGet(`/api/new`);

        table = new Tabulator(tableElement, {
            height: "100%",
            data: products,
            layout: "fitDataFill",
            vertAlign: "middle",
            index: "sku",
            columns: productsTableColumns,
        });

        table.on("tableBuilt", () => {
            if ($scrollToSku) {
                table.scrollToRow($scrollToSku, "top", true);
                $scrollToSku = null;
            }
        });

        $isLoading = false;
    });
</script>

<div class="container">
    <div class="header">
        <b>{getLocaleResource($locale, "newProducts")}</b>
        <div class="count">{products.length}</div>
    </div>

    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        grid-template-rows: auto 1fr;
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /* background: #ccc; */
        padding: 10px;
    }

    .count {
        font-weight: bold;
        opacity: 0.3;
        margin-left: 10px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }

    .table {
        border-radius: 3px;
    }
</style>
